import { useTranslation } from 'react-i18next';
import {
  statusBadgeClasses,
  type StatusBadgeTone,
} from '~/components/ui/statusBadgeClasses';
import { BuyListStatus } from '~/graphql/graphql';

const TONE_BY_STATUS: Record<BuyListStatus, StatusBadgeTone> = {
  [BuyListStatus.Open]: 'accepted',
  [BuyListStatus.Fulfilled]: 'shipped',
  [BuyListStatus.Closed]: 'neutral',
};

type BuyListStatusBadgeProps = {
  readonly status: BuyListStatus;
  readonly testId: string;
};

export function BuyListStatusBadge({
  status,
  testId,
}: BuyListStatusBadgeProps) {
  const { t } = useTranslation('inventory');

  return (
    <span
      className={`${statusBadgeClasses(TONE_BY_STATUS[status])} whitespace-nowrap`}
      data-testid={testId}
    >
      {t(`inventory.buy_list.status.${status}`)}
    </span>
  );
}
